import {getCart} from '@/cart/cart-store';

/**
 * Component to display the number of items in the cart.
 * @returns The number of items in the cart, or null if the cart is empty or has more than 999 items.
 * If the cart is null, it returns null.
 */
const CartItemsCount = () => {
  const cart = getCart();
  const count = cart?.item_count ?? 0;
  if (!cart || count === 0 || count > 999) {
    return null;
  }
  return <>{count}</>;
};

export default CartItemsCount;
